<template>
  <div class="system">
    <div class="centent">
      <div class="title" style="margin-bottom: 80px">人工智能人才培养体系</div>
      <div class="grid">
        <img src="../aiImg/img_nengli@2x.png" width="497px" alt="" />
        <div
          class="point"
          :class="`point${index}`"
          v-for="(item, index) in gridData"
          :key="index"
        >
          <div class="tit">{{ item.tit }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'system',
  data() {
    return {
      gridData: [
        { tit: '问题解决能力', desc: '终点讲解解决方案思路及应用场景' },
        { tit: '业务分析能力', desc: '全套产品文档，培养业务分析能力' },
        { tit: '项目沟通能力', desc: '项目实战课程由学生亲自操练' },
        { tit: '学习探索能力', desc: '引导式教学，培养学习能力' },
        {
          tit: '团队协作能力',
          desc: '版本控制、错误报告、自动化、强化团队协作能力',
        },
        { tit: 'AI项目开发能力', desc: '亲历项目从开始到上线的全周期开发' },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.system {
  background: #f4fafe;
  position: relative;
  padding-bottom: 85px;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #19232b;
  }
  .centent {
    padding-top: 70px;
    position: relative;
    z-index: 2;
    width: 80%;
    min-width: 1180px;
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 110px;
    text-align: center;
    .grid {
      position: relative;
      width: 1180px;
      margin: 0 auto;
      // opacity: 0;
      .point {
        position: absolute;
        left: 17%;
        top: 0;
        .tit {
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Semibold;
          font-weight: 600;
          text-align: right;
          color: #000000;
          line-height: 30px;
        }
        .desc {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: right;
          color: #616a72;
          line-height: 30px;
        }
      }
      .point1 {
        left: 63%;
        top: 0;
        .tit {
          text-align: left;
        }
      }
      .point2 {
        left: 72%;
        top: 42%;
        .tit {
          text-align: left;
        }
      }
      .point3 {
        left: 63%;
        top: 86%;
        .tit {
          text-align: left;
        }
      }
      .point4 {
        left: 7%;
        top: 87%;
      }
      .point5 {
        left: 6.5%;
        top: 43%;
      }
      .point6 {
        left: 40%;
        top: 21%;
      }
    }
  }
  &::after,
  &::before {
    content: '';
    display: inline-block;
    // background: url('./images/img/bg_right.png') left top no-repeat;
    background-size: contain;
    position: absolute;
    width: 180px;
    height: 182px;
    left: 0;
    top: 50px;
  }
  &::after {
    // background: url('./images/img/bg_left.png') left top no-repeat;
    background-size: contain;
    left: auto;
    right: 0px;
    width: 172px;
    height: 188px;
    top: 260px;
  }
}
</style>
